import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";
import { lookMoments } from "@/mocks/looks";

export default function LooksMoments() {
  return (
    <section id="looks" className="w-full bg-background-50 scroll-mt-24" aria-label="Looks para cada momento">
      <div className="px-4 py-16 md:px-8 md:py-24">
        <div className="mx-auto max-w-7xl">
          <SectionHeading
            eyebrow="Inspiração de looks"
            title="Looks para cada momento"
            text="Cada rotina pede um jeito de vestir. Reunimos combinações pensadas para os seus dias mais diferentes."
          />

          <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8">
            {lookMoments.map((moment, index) => (
              <Reveal key={moment.id} delay={(index % 2) * 90}>
                <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
                  <h3 className="font-heading text-2xl text-foreground-900 md:text-3xl">{moment.title}</h3>
                  <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{moment.description}</p>

                  <div className="mt-5 grid flex-1 grid-cols-2 gap-3">
                    {moment.images.map((image, imageIndex) => (
                      <div
                        key={image}
                        className="relative h-[260px] overflow-hidden rounded-md bg-background-200 md:h-[320px]"
                      >
                        <img
                          src={image}
                          alt={`Look ${moment.title} — peça ${imageIndex + 1} da Amora Belle`}
                          title={`${moment.title} — moda feminina Amora Belle`}
                          className="h-full w-full object-cover object-top transition-transform duration-700 ease-out hover:scale-105"
                        />
                      </div>
                    ))}
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}